<template>
  <el-card class="h-full absolute inset-0 z-10">
    <div class="h-full flex flex-col">
      <span
        v-if="['update', 'create'].includes(formProps.editType)"
        class="border-l-3 border-color-primary pl-10px text-18px"
        >{{ formProps.editType === 'create' ? '新增隐患' : '编辑隐患' }}</span
      >
      <div v-else>
        <el-page-header @back="$emit('cancel')" content="隐患详情"> </el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto mt-20px">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="隐患基本信息" name="baseInfo">
            <div class="mb-10px text-right" v-if="formData.workflowTaskId">
              <el-button size="mini" @click="viewProcess(formData)">查看流程</el-button>
            </div>
            <el-form
              ref="formData"
              label-width="150px"
              :model="formData"
              :disabled="!['update', 'create'].includes(formProps.editType)"
            >
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患描述" prop="hiddenDangerName">
                    <el-input
                      v-model="formData.hiddenDangerName"
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 6 }"
                      placeholder="请输入隐患描述"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患编码" prop="hiddenDangerCode">
                    <el-input
                      v-model="formData.hiddenDangerCode"
                      placeholder="请输入隐患编码"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患类别" :rules="[{ required: true, message: '请选择隐患类别', trigger: 'change' }]" prop="hiddenDangerCategory">
                    <el-select
                      v-model="formData.hiddenDangerCategory"
                      class="w-full"
                      filterable
                      clearable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in hiddenCategoryList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="所属风险区域" prop="areaId">
                    <el-select
                      v-model="formData.areaId"
                      class="w-full"
                      clearable
                      filterable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in areaList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患来源" prop="hiddenDangerSource">
                    <el-select
                      v-model="formData.hiddenDangerSource"
                      class="w-full"
                      clearable
                      filterable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in hiddenSourceList"
                        :key="item.value"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患等级" prop="hiddenDangerlevel">
                    <el-select
                      v-model="formData.hiddenDangerlevel"
                      class="w-full"
                      clearable
                      filterable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in hiddenLevelList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <!-- <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患类型" prop="hiddenDangerType">
                    <el-select
                      v-model="formData.hiddenDangerType"
                      class="w-full"
                      filterable
                      clearable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in hiddenTypeList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="Number(item.code)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
              </el-row>
              <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="所属系统/机组" prop="ownedSystemOrUnit">
                    <el-select
                      multiple
                      v-model="formData.ownedSystemOrUnit"
                      class="w-full"
                      filterable
                      clearable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in ownedSystemOrUnitList"
                        :key="item.id"
                        :label="item.displayName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患可能危害" prop="hiddenDangerHarm">
                    <el-input
                      v-model="formData.hiddenDangerHarm"
                      placeholder="请输入隐患可能危害"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="上报人" prop="reporterName">
                    <el-input
                      v-model="formData.reporterName"
                      clearable
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="上报时间" prop="reportTime">
                    <el-date-picker
                      size="small"
                      v-model="formData.reportTime"
                      :disabled="formProps.editType === 'read'"
                      type="datetime"
                      class="!w-full"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      clearable
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患归属" prop="hiddenDangerBelong">
                    <el-select
                      v-model="formData.hiddenDangerBelong"
                      class="w-full"
                      clearable
                      filterable
                      :disabled="formProps.editType === 'read'"
                    >
                      <el-option
                        v-for="item in sectionList"
                        :key="item.code"
                        :label="item.displayName"
                        :value="item.code"
                      ></el-option>
                    </el-select> </el-form-item
                ></el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="安全检查标题">
                    <el-input
                      v-model="formData.safetyInspectionTitle"
                      class="w-full"
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="安全检查期数">
                    <el-input
                      v-model="formData.safetyInspectionPeriods"
                      class="w-full"
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="建议整改措施">
                    <el-input
                      v-model="formData.suggestedRectificationMeasures"
                      class="w-full"
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 6 }"
                      :disabled="formProps.editType === 'read'"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="整改前图片"
                    prop="photosBeforeRectification"
                    ref="photosBeforeRectification"
                    v-if="formProps.editType !== 'read'"
                  >
                    <img-upload
                      v-model="formData.photosBeforeRectification"
                      :upload-width="120"
                      :upload-height="120"
                      :maxSize="20"
                      :limit="99"
                      :isDisabledUploadComponent="formProps.editType === 'read'"
                      :isShowDeleteButton="formProps.editType !== 'read'"
                    ></img-upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <template v-if="formData.isCheckCorrect">
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item label="隐患整改期限" prop="hiddenDangerRectificationPeriod">
                    <el-date-picker
                      size="small"
                      v-model="formData.hiddenDangerRectificationPeriod"
                      :disabled="formProps.editType === 'read'"
                      type="datetime"
                      class="!w-full"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      clearable
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="隐患整改负责人"
                    prop="personChargeHiddenDangerRectificationId"
                    ref="personChargeHiddenDangerRectificationId"
                  >
                    <person-select
                      v-model="formData.personChargeHiddenDangerRectificationId"
                      :disabled="['read', 'refreshPublish'].includes(formProps.editType)"
                    ></person-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                  <el-form-item
                    label="隐患验收负责人"
                    prop="personChargeHiddenDangerAcceptanceId"
                    ref="personChargeHiddenDangerAcceptanceId"
                  >
                    <person-select
                      v-model="formData.personChargeHiddenDangerAcceptanceId"
                      :disabled="['read', 'refreshPublish'].includes(formProps.editType)"
                    ></person-select>
                  </el-form-item>
                </el-col>
              </template>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <!-- 查看流程start -->
    <ApprovalFlowDialog
      :visible.sync="showFlowDialog"
      v-if="showFlowDialog"
      :id="formData.workflowTaskId"
    ></ApprovalFlowDialog>
    <!-- 查看流程end -->
  </el-card>
</template>

<script>
import uuid from 'uuid'

import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import utils from '@/components/safety/enumField/utils'
import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import ImgUpload from '@/components/safety/ImgUpload/ImgUpload'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'
import PointSelect from '../PointSelect/PointSelect'

const areaApi = new AreaApi()

export default {
  name: 'hidden-list-detail',
  components: {
    PersonSelect,
    ImgUpload,
    ApprovalFlowDialog,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    formProps: {
      default: () => {
        return {
          title: '',
          editType: 'create',
          visible: true,
        }
      },
    },
  },
  data() {
    return {
      areaList: [],
      hiddenCategoryList: [],
      hiddenTypeList: [],
      hiddenLevelList: [],
      hiddenSourceList: [],
      ownedSystemOrUnitList: [],
      changeTypeList: [
        { label: '立即整改', value: true },
        { label: '期限整改', value: false },
      ],
      formData: {},
      rules: {},
      collapseActiveName: ['baseInfo'],
      showFlowDialog: false, // 是否显示审批流程页面
      sectionList: [],
    }
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData = JSON.parse(JSON.stringify(newVal))
        } else {
          this.formData = {}
        }
      },
      immediate: true,
    },
  },
  computed: {},
  created() {
    this.getAreaList()
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.HiddenSource',
        'DoublePreventionManagement.DataCategory.HiddenLevel',
        'DoublePreventionManagement.DataCategory.HiddenType',
        'DoublePreventionManagement.DataCategory.HiddenCategory',
        'DoublePreventionManagement.DataCategory.OwnedSystemOrUnit',
        'DoublePreventionManagement.DataCategory.HiddenDangerBelong',
      ],
      [
        'hiddenSourceList',
        'hiddenLevelList',
        'hiddenTypeList',
        'hiddenCategoryList',
        'ownedSystemOrUnitList',
        'sectionList',
      ],
      this
    )
  },
  mounted() {},

  methods: {
    viewProcess() {
      if (
        typeof this.formData.workflowTaskId === 'string' &&
        _.includes(this.formData.workflowTaskId, '-')
      ) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.formData.workflowTaskId)
        return
      }
      this.showFlowDialog = true
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    validatorPerson(rule, value, callback) {
      if (!value) {
        callback(new Error(rule.message))
      }
      if (
        this.formData.personChargeHiddenDangerRectificationId ===
        this.formData.personChargeHiddenDangerAcceptanceId
      ) {
        callback(new Error('隐患整改负责人和隐患验收负责人不能是同一人!'))
        return
      }
      callback()
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
::v-deep .el-badge__content {
  top: 10px;
}
</style>
